<template>
  <ul class="resouce-tab">
    <li
      v-for="item in tabs"
      :key="item.type + 'tabs'"
      :class="{ active: currentType === item.type }"
      @click="chooseTab(item)"
      :style="{ width: tabWidth }"
    >
      <span>  
        {{ item.name }}
      </span>

    </li>
  </ul>
</template>

<script>
export default {
  name: "resouceTab",
  props: {
    currentType: {
      type: String,
      default: "all",
    },
    tabWidth:{
      type: String,
       default: "33%",
    },
    tabs: {
      type: Array,

      default: function () {
        return [
          {
            name: "全部",
            type: "all",
          },
          {
            name: "最近使用",
            type: "recent",
          },
          {
            name: "收藏",
            type: "collect",
          },
        ];
      },
    },
  },
  created() {
  },
  computed: {
    // tabWidth() {
    //   return 100 / this.tabs.length;
    // },
  },
  data() {
    return {
      // tabs: [{
      //     name: '全部',
      //     type: 'all'
      // },{
      //     name: '最近使用',
      //     type: 'recent'
      // },{
      //     name: '收藏',
      //     type: 'collect'
      // }]
    };
  },
  methods: {
    chooseTab(item) {
      this.$emit("chooseTab", item.type);
    },
  },
};
</script>

<style lang="scss" scoped>
.resouce-tab {
  width: 100%;
  font-size: 14px;
  line-height: 20px;
  border-bottom: 1px solid #e6e6e6;
  box-sizing: border-box;
  display: flex;
  justify-content: space-around;

  li {
    margin: 0 14px;
    text-align: center;
    color: #474261;
    cursor: pointer;
    opacity: 0.4;

    &::after {
      display: block;
      position: relative;
      top: 1px;
      content: "";
      width: 100%;
      height: 2px;
      margin-top: 6px;
      background: #5778fb;
      box-shadow: 0px 2px 4px rgba(101, 101, 255, 0.4);
      opacity: 0;
    }
    &.active {
      font-weight: bold;
      opacity: 1;
      &::after {
        opacity: 1;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/common/resourceTab.vue